import {
  BUCKET_MENU_ITEMS_TYPES,
  COMMUNICATION_PATH,
  ROOT,
} from '../components/expertDashboardModule/expertSettingsComponent/leftNavigationData';

let privateState = {};
let service = {};

service.setResetExpertHomeContextAndRootNavFunc = (
  resetExpertHomeContextAndRootNav,
) => {
  privateState.resetExpertHomeContextAndRootNav =
    resetExpertHomeContextAndRootNav;
};

service.resetExpertHomeContextAndRootNav = () => {
  if (privateState.resetExpertHomeContextAndRootNav) {
    privateState.resetExpertHomeContextAndRootNav();
  }
};

service.setRootNavElement = (setRootNavElement) => {
  privateState.setContextRootNavElement = setRootNavElement;
};

service.updateRootNavElement = () => {
  let tempRoot = {...ROOT};
  service.assignParents(ROOT);
  privateState.setContextRootNavElement(tempRoot);
};

service.assignParents = (navElement) => {
  if (Array.isArray(navElement.children)) {
    navElement.children.forEach((child) => {
      child._parentNavElement = navElement;
      service.assignParents(child);
    });
  }
};

service.findFirstAncestorSubMenu = (element) => {
  element = service.getParentElement(element);
  while (
    element?.type !== BUCKET_MENU_ITEMS_TYPES.SUB_MENU &&
    service.getParentElement(element)
  ) {
    element = service.getParentElement(element);
  }
  return element;
};

service.getChildByKey = (routeItem, key) => {
  if (!service.hasChildren(routeItem)) return null;
  const childItem = routeItem.children.find((item) => item.urlKey === key);
  return childItem;
};

service.getFirstChild = (routeItem) => {
  if (!service.hasChildren(routeItem)) return null;
  return routeItem.children.find((routeItem) => routeItem.isViewable);
};

service.getViewableChildrenCount = (routeItem) => {
  if (!service.hasChildren(routeItem)) return 0;
  return routeItem.children.filter((routeItem) => routeItem.isViewable)?.length;
};

service.getMutualAncestor = (/* elementA, elementB */) => {};

service.getParentElement = (element) => {
  return element?._parentNavElement;
};

service.getPathToRoot = (element) => {
  if (element._parentNavElement) {
    const path = [
      ...service.getPathToRoot(service.getParentElement(element)),
      element,
    ];
    return path;
  } else {
    return [element];
  }
};

service.hasChildren = (routeItem) => {
  if (
    (routeItem?.type === BUCKET_MENU_ITEMS_TYPES.BUCKET_MENU ||
      routeItem?.type === BUCKET_MENU_ITEMS_TYPES.SUB_MENU ||
      routeItem?.type === BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU ||
      BUCKET_MENU_ITEMS_TYPES.SHORTCUTS_MENU) &&
    routeItem?.children?.length > 0
  )
    return true;
  return false;
};

service.isAncestorOf = (routeItem, navMenuItemId) => {
  if (routeItem?.navMenuItemId === navMenuItemId) {
    return routeItem;
  } else {
    const parent = service.getParentElement(routeItem);
    if (parent) {
      return service.isAncestorOf(parent, navMenuItemId);
    } else {
      return null;
    }
  }
};

service.updateNavElementsIsViewable = (data) => {
  //data = [{url, isViewable}, {url, isViewable}, ...]
  data.forEach(({url, isViewable}) => {
    let selectedItem = service.getNavElementUsingUrl(url);
    selectedItem.isViewable = isViewable;
    //update the children of selectedItem with same isViewable
    if (service.hasChildren(selectedItem)) {
      privateState.updateChildrenViewability(selectedItem, isViewable);
    }
  });
};

service.updateNavElementsPillType = (data) => {
  //data = [{url, pillType}, {url, pillType}, ...]
  data.forEach(({url, pillType}) => {
    let selectedItem = service.getNavElementUsingUrl(url);
    if (pillType) {
      selectedItem.pillType = pillType;
    } else {
      delete selectedItem.pillType;
    }
  });
};

privateState.updateChildrenViewability = (selectedItem, isViewable) => {
  selectedItem.isViewable = isViewable;
  if (service.hasChildren(selectedItem)) {
    selectedItem.children.forEach((child) => {
      privateState.updateChildrenViewability(child, isViewable);
    });
  }
};

service.getNavElementUsingUrl = (url) => {
  if (service.isCommunicationTabUrl(url)) {
    url = service.getManipulatedCommunicationNavUrl(url);
  }
  const pathKeys = url.split('/');
  const pathDepth = pathKeys.length;
  let selectedItem = ROOT.children.find(
    (child) => child.urlKey === pathKeys[0],
  );
  if (selectedItem.urlKey === pathKeys[pathDepth - 1]) {
    return selectedItem;
  }
  for (let idx = 0; idx < pathDepth - 1; idx++) {
    if (service.hasChildren(selectedItem)) {
      const selectedChild = service.getChildByKey(
        selectedItem,
        pathKeys[idx + 1],
      );
      if (!selectedChild) {
        return null;
      }
      selectedItem = selectedChild;
    }
    if (selectedItem.urlKey === pathKeys[pathDepth - 1]) {
      return selectedItem;
    }
  }
};

service.isCommunicationTabUrl = (navUrl) => {
  return navUrl?.includes('/communication/');
};

service.getManipulatedCommunicationNavUrl = (navUrl) => {
  let manipulatedUrl = navUrl;
  //Sample URLs :
  // - https://my-ip.yuvidio.com:3000/expertHome/settings/widgetSetup/setUpInstallation/communication/appearance/appearanceOrder
  //-  https://my-ip.yuvidio.com:3000/expertHome/settings/widgetSetup/setUpInstallation/communication/communicationTextChat/tabSetup

  // this method adds activeChannels or inActiveChannels to navUrl
  //1. find the communicationTab nav element
  //2. find the navKey of child provided in navUrl (next  to communication ie. appearance or communicationTextChat)
  //3. if childObj exist then it means the selected tab is appearance -> no need to manipulate url
  //4. else child is inside either activeChannels or inActiveChannels

  const communicationTabKey = 'communication';
  const communicationTabUrl = COMMUNICATION_PATH;

  const communicationTabElement =
    service.getNavElementUsingUrl(communicationTabUrl);
  const communicationKeyIdxInUrl = navUrl.indexOf(`/${communicationTabKey}/`);

  const firstChildKeyFromUrl = navUrl
    .slice(communicationKeyIdxInUrl + communicationTabKey.length)
    .split('/')[1];

  const childObj = service.getChildByKey(
    communicationTabElement,
    firstChildKeyFromUrl,
  );

  if (childObj) {
    return manipulatedUrl;
  } else {
    const activeOrInActiveNavElement = communicationTabElement.children.find(
      (child) => {
        return child.children.find(
          (child) => child.urlKey === firstChildKeyFromUrl,
        );
      },
    );
    const urlTillCommunicationKey = navUrl.slice(
      0,
      communicationKeyIdxInUrl + communicationTabKey.length + 2,
    );
    const urlAfterCommunicationKey = navUrl.slice(
      communicationKeyIdxInUrl + communicationTabKey.length + 1,
    );
    manipulatedUrl =
      urlTillCommunicationKey +
      activeOrInActiveNavElement?.urlKey +
      urlAfterCommunicationKey;
  }
  return manipulatedUrl;
};

service.getHeaderOptionsUsingNavElement = (navElement) => {
  let headerOptions = [];
  if (navigationService.hasChildren(navElement)) {
    navElement.children.forEach((child) => {
      const option = {
        id: child.urlKey,
        navMenuItemId: child.navMenuItemId,
        text: child.navText,
        hideTab: !child.isViewable,
        pillType: child.pillType,
      };
      headerOptions.push(option);
    });
  }
  return headerOptions;
};

service.getSidePaneOptionsUsingNavElement = (navElement) => {
  let sidePaneOptions = [];
  if (navigationService.hasChildren(navElement)) {
    navElement.children.forEach((child) => {
      const option = {
        id: child.urlKey,
        navMenuItemId: child.navMenuItemId,
        btnText: child.navText,
        hideTab: !child.isViewable,
      };
      sidePaneOptions.push(option);
    });
  }
  return sidePaneOptions;
};

const navigationService = {...service};
export default navigationService;
